var _circle, _circle2, _rect, _rect2, _rect3, _circle3, _circle4, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectionMediaDailySale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFD8D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 32.5,
    r: 16,
    stroke: "#D91F05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.52601,
    height: 0.860292,
    transform: "matrix(0.661648 -0.749815 0.953865 0.300234 24.7246 31.2402)",
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.52601,
    height: 0.860292,
    transform: "matrix(0.921443 0.388513 0.72916 -0.684343 28.5283 27.4775)",
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.52601,
    height: 0.860292,
    transform: "matrix(0.661648 -0.749815 0.953865 0.300234 33.0566 29.3389)",
    fill: "#D91F05"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 27,
    r: 1,
    fill: "#D91F05"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 29,
    r: 1,
    fill: "#D91F05"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 33.5,
    width: 2,
    height: 6,
    rx: 0.5,
    stroke: "#D91F05"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 31.5,
    width: 2,
    height: 8,
    rx: 0.5,
    stroke: "#D91F05"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 29.5,
    width: 2,
    height: 10,
    rx: 0.5,
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectionMediaDailySale);
export default __webpack_public_path__ + "static/media/projection_media_daily_sale.b833be5cdc59d0f4bf9a4eec5bb87841.svg";
export { ForwardRef as ReactComponent };